import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../../../reduxStore/utils/reduxHooks';
import roleConfig from '../../../config/config.role';
import { canAccessRoute } from '../../utils/rbac';
import type { IRoute } from '../../../config/config.route';
import Loading from '../loading/Loading';
import services from '../../../app/config/services';
import { routes } from '../../../config/config.routeName';

interface Props {
  route: IRoute;
  children: React.ReactNode;
}

const RouteGuard: React.FC<Props> = ({ route, children }) => {
  const { role, rolePages, authReady } = useAppSelector((state) => state.auth);
  const currentRole = role || roleConfig.anonymous;

  if (!authReady) {
    return <Loading />;
  }

  if (canAccessRoute(route, currentRole, rolePages)) {
    return children as React.ReactElement;
  }

  return (
    <Navigate to={`/${services.getLocale()}${routes.MARKDOWN}`} replace />
  );
};

export default RouteGuard;
